import React from 'react';
import HttpStatus from 'http-status-codes';
import { Alert } from 'reactstrap';
import { useTranslation } from 'react-i18next';

export default function ErrorPage({ error }) {
	const { t } = useTranslation();
	let title = 'Error.Unknown';
	let message = 'Error.Unknown.Message';
	const args = [];
	if(error.response) {
		const { status, data } = error.response;
		if(status === HttpStatus.NOT_FOUND) {
			title = 'Error.NotFound';
			message = 'Error.NotFound.Message';
		} else if(status === HttpStatus.FORBIDDEN) {
			title = 'Error.Forbidden';
			message = 'Error.Forbidden.Message';
		} else if(status === HttpStatus.BAD_REQUEST && data && data.invalid) {
			title = 'Error.Invalid';
			message = 'Error.Invalid.Message';
			args.push({ fields: data.invalid.join(', ') });
		} else if(status === HttpStatus.REQUEST_TOO_LONG) {
			title = 'Error.Invalid';
			message = 'Error.FileSize.Message';
		}
	}
	return <main className="bg-white container p-4 mt-5">
		<Alert color="danger" className="mb-0">
			<h1>{t(title)}</h1>
			<p className="mb-0">{t(message, ...args)}</p>
		</Alert>
	</main>;
}
